export default __webpack_public_path__ + "static/media/catlist_img2.30180d57.png";